import { createStore } from 'vuex';
import { getModule } from 'vuex-module-decorators';

// 2.6 
import { CompAddressActions, CompAddressGetters, CompAddressMutations, CompAddressStore } from './2.6/CompAddressStore';
import MlsStoreModule from './2.6/MlsStoreModule';
import OriginalValuesStoreModule from './2.6/OriginalValuesStoreModule';
import SalesHistoryStoreModule from './2.6/SalesHistoryStoreModule';
import SmartExchangeStoreModule from './2.6/SmartExchangeStoreModule';
import FormFieldStoreModule from './2.6/FormFieldStoreModule';

// 3.6 
import { CompAddressActionsV36, CompAddressGettersV36, CompAddressMutationsV36, CompAddressStoreV36 } from './3.6/CompAddressStore';
import MlsStoreModuleV36 from './3.6/MlsStoreModule';
import OriginalValuesStoreModuleV36 from './3.6/OriginalValuesStoreModule';
import SalesHistoryStoreModuleV36 from './3.6/SalesHistoryStoreModule';
import SmartExchangeStoreModuleV36 from './3.6/SmartExchangeStoreModule';
import FormFieldStoreModuleV36 from './3.6/FormFieldStoreModule';

// Generic stores
import UserSettingsStoreModule from './UserSettingsStoreModule';
import MiscSettingsStoreModule from './MiscSettingsStoreModule';

/* ========== VUEX STORE ==========
When using the store, please follow these guidelines:

1) Always put like state with each other in cohesive, reasonably small stores.
2) Never change the state directly, rather use mutations
3) Only reference Getters/Mutations through the const variables (no magic strings!)
    ex. $store.getters[Getters.<MODULE>.<KEY>]
        $store.commit(Mutations.<MODULE>.<KEY>, payload)
4) When possible, directly read the state and only use getters like computed properties 
    ex. $store.state.<MODULE>.<KEY>             // simple read
        $store.getters[Getters.<MODULE>.<KEY>]  // value derived from state

  ============================================= */

// This method prepends a given route to a Mutation/Getter object, allowing the module to define
// the keys and the upper level Mutations/Getters object to define the route to each module.
function withRouting<T>(object: T, routeName: string): T {
    const newObject = JSON.parse(JSON.stringify(object));
    Object.keys(newObject).forEach((key) => (newObject[key] = routeName + newObject[key]));
    return newObject;
}

export const Getters = {
    CompAddresses: withRouting<typeof CompAddressGetters>(CompAddressGetters, 'compAddresses/'),
    CompAddressesV36: withRouting<typeof CompAddressGettersV36>(CompAddressGettersV36, 'compAddressesV36/'),
};

export const Actions = {
    CompAddresses: withRouting<typeof CompAddressActions>(CompAddressActions, 'compAddresses/'),
    CompAddressesV36: withRouting<typeof CompAddressActionsV36>(CompAddressActionsV36, 'compAddressesV36/'),
};

export const Mutations = {
    CompAddresses: withRouting<typeof CompAddressMutations>(CompAddressMutations, 'compAddresses/'),
    CompAddressesV36: withRouting<typeof CompAddressMutationsV36>(CompAddressMutationsV36, 'compAddressesV36/'),
};

export const store = createStore({
    modules: {
        compAddresses: CompAddressStore,
        mls: MlsStoreModule,
        originalValues: OriginalValuesStoreModule,
        salesHistory: SalesHistoryStoreModule,
        smartExchange: SmartExchangeStoreModule,
        formField: FormFieldStoreModule,
        userSettings: UserSettingsStoreModule,
        miscSettings: MiscSettingsStoreModule,

        compAddressesV36: CompAddressStoreV36,
        mlsV36: MlsStoreModuleV36,
        originalValuesV36: OriginalValuesStoreModuleV36,
        salesHistoryV36: SalesHistoryStoreModuleV36,
        formFieldV36: FormFieldStoreModuleV36,
        smartExchangeV36: SmartExchangeStoreModuleV36,

    },
    strict: process.env.NODE_ENV !== 'production',
});

const mlsStore = getModule(MlsStoreModule, store);
const originalValuesStore = getModule(OriginalValuesStoreModule, store);
const salesHistoryStore = getModule(SalesHistoryStoreModule, store);
const smartExchangeStore = getModule(SmartExchangeStoreModule, store);
const userSettingsStore = getModule(UserSettingsStoreModule, store);
const formFieldsStore = getModule(FormFieldStoreModule, store);
const miscSettingsStore = getModule(MiscSettingsStoreModule, store);

const mlsStoreV36 = getModule(MlsStoreModuleV36, store);
const originalValuesStoreV36 = getModule(OriginalValuesStoreModuleV36, store);
const salesHistoryStoreV36 = getModule(SalesHistoryStoreModuleV36, store);
const formFieldsStoreV36 = getModule(FormFieldStoreModuleV36, store);
const smartExchangeStoreV36 = getModule(SmartExchangeStoreModuleV36, store);


export { 
        mlsStore, originalValuesStore, salesHistoryStore, smartExchangeStore, formFieldsStore, userSettingsStore, miscSettingsStore,
        mlsStoreV36, originalValuesStoreV36, salesHistoryStoreV36, smartExchangeStoreV36, formFieldsStoreV36, 
 };
